(function () {
	var root = document.querySelector("[data-hp-hub]");
	if (!root) return;

	var lastVehicleJson = null;
	var pollInterval = null;
	var pollCount = 0;

	/* ── Anti-loop: AbortController for in-flight fetches ── */
	var _fetchController = null;
	var _vehicleChangeTimer = null;
	const vehicleRecoveryLinkContexts = new WeakMap();
	const observedVehicleRecoveryLinks = new WeakSet();

	function recordVehicleCollectionNavigation(destination, vehicle) {
		try {
			const recovery = window.PartifyVehicleCollectionRecovery;
			if (recovery && typeof recovery.record === "function") {
				recovery.record(destination, vehicle);
			}
		} catch (e) {}
	}

	function observeVehicleCollectionLink(link, vehicle) {
		if (!link) return;

		if (vehicle) {
			vehicleRecoveryLinkContexts.set(link, vehicle);
		} else {
			vehicleRecoveryLinkContexts.delete(link);
		}

		if (observedVehicleRecoveryLinks.has(link)) return;
		observedVehicleRecoveryLinks.add(link);
		link.addEventListener("click", function (event) {
			if (event.defaultPrevented) return;
			const recoveryVehicle = vehicleRecoveryLinkContexts.get(link);
			if (!recoveryVehicle) return;
			const destination = link.getAttribute("href") || link.href;
			recordVehicleCollectionNavigation(destination, recoveryVehicle);
		});
	}

	// Read fallback handle from data attribute with fallback chain
	var fallbackHandle =
		root.getAttribute("data-hp-fallback-collection") || "top-sellers";
	if (!fallbackHandle || fallbackHandle === "") fallbackHandle = "top-sellers";
	// Final fallback to "all" if top-sellers doesn't exist
	var ultimateFallback = "all";

	// Ensure image fixer exists for product cards
	if (typeof window.fixProductImage !== "function") {
		window.fixProductImage = function (imgUrl) {
			if (!imgUrl)
				return "https://cdn.shopify.com/s/files/1/0000/0000/files/placeholder.jpg";
			if (imgUrl.indexOf("//") === 0) return "https:" + imgUrl;
			return imgUrl;
		};
	}

	function safeParse(json) {
		try {
			return JSON.parse(json);
		} catch (e) {
			return [];
		}
	}

	function slugify(str) {
		return String(str || "")
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "");
	}

	function getActiveVehicle() {
		// Canonical getter: prefer window.getGarageSearchTerms, fallback to localStorage
		if (typeof window.getGarageSearchTerms === "function") {
			try {
				var vehicles = window.getGarageSearchTerms();
				if (Array.isArray(vehicles) && vehicles.length > 0) return vehicles[0];
			} catch (e) {}
		}
		var raw = localStorage.getItem("searchTerms");
		var arr = safeParse(raw);
		if (!Array.isArray(arr) || arr.length === 0) return null;
		return arr[0];
	}

	function computeVehicleCollectionHandle(vehicle) {
		if (!vehicle) return "";

		// Prefer vehicle.lastCollection or vehicle.collectionHandle
		if (vehicle.lastCollection) {
			var lc = String(vehicle.lastCollection);
			if (lc.indexOf("/collections/") === 0)
				return slugify(lc.replace("/collections/", ""));
			return slugify(lc);
		}
		if (vehicle.collectionHandle)
			return slugify(String(vehicle.collectionHandle));

		// Try window.generateCollectionHandle
		if (typeof window.generateCollectionHandle === "function") {
			try {
				var ymmStr = vehicle && vehicle.ymm ? String(vehicle.ymm) : "";
				if (!ymmStr && vehicle) {
					var y = vehicle.year ? String(vehicle.year) : "";
					var mk = vehicle.make ? String(vehicle.make) : "";
					var md = vehicle.model ? String(vehicle.model) : "";
					var sm = vehicle.submodel ? String(vehicle.submodel) : "";
					var en = vehicle.engine ? String(vehicle.engine) : "";
					ymmStr = (y + " " + mk + " " + md + " " + sm + " " + en)
						.replace(/\s+/g, " ")
						.trim();
				}
				var handle = window.generateCollectionHandle(ymmStr);
				if (handle) return slugify(handle);
			} catch (e) {}
		}

		// Fallback: slugify YMM
		var ymm =
			vehicle.ymm ||
			(vehicle.year || "") +
				" " +
				(vehicle.make || "") +
				" " +
				(vehicle.model || "");
		return slugify(ymm);
	}

	function computeVehicleCollectionUrl(vehicle) {
		var handle = computeVehicleCollectionHandle(vehicle);
		return handle ? "/collections/" + handle : "";
	}

	function extractImageUrl(product) {
		var imgCandidate = null;

		// Priority: featured_image string or object, images array, fallback
		if (product.featured_image) {
			if (typeof product.featured_image === "string") {
				imgCandidate = product.featured_image;
			} else if (product.featured_image.src) {
				imgCandidate = product.featured_image.src;
			}
		}

		if (!imgCandidate && product.images && product.images.length > 0) {
			var firstImg = product.images[0];
			if (typeof firstImg === "string") {
				imgCandidate = firstImg;
			} else if (firstImg && firstImg.src) {
				imgCandidate = firstImg.src;
			}
		}

		if (!imgCandidate) {
			return (
				window.hpHubNoImageUrl || "data:image/gif;base64,R0lGODlhAQABAAAAACw="
			);
		}

		// Normalize protocol-relative URLs
		if (imgCandidate.indexOf("//") === 0) return "https:" + imgCandidate;
		return imgCandidate;
	}

	function formatPrice(priceInCents) {
		if (!priceInCents || priceInCents === 0) return "";
		return "$" + (priceInCents / 100).toFixed(2);
	}

	function renderProductCard(product) {
		var card = document.createElement("a");
		card.className = "hp-a-prodcard";
		card.href = product.url || "/products/" + product.handle;

		var media = document.createElement("div");
		media.className = "hp-a-prodcard__media";

		var imgUrl = extractImageUrl(product);
		if (typeof window.fixProductImage === "function") {
			imgUrl = window.fixProductImage(imgUrl);
		}

		// Use fallback image if URL is base64 or doesn't contain cdn.shopify.com
		if (
			!imgUrl ||
			imgUrl.indexOf("data:image") === 0 ||
			imgUrl.indexOf("cdn.shopify.com") === -1
		) {
			imgUrl =
				"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Partify_Photo_Coming_Soon.png?v=1747228850";
		}

		var img = document.createElement("img");
		img.loading = "lazy";
		img.alt = product.title || "";
		img.style.opacity = "0";
		img.style.transition = "opacity .25s ease";
		img.onload = function () {
			img.style.opacity = "1";
		};
		img.src = imgUrl;
		media.appendChild(img);

		var body = document.createElement("div");
		body.className = "hp-a-prodcard__body";

		var title = document.createElement("div");
		title.className = "hp-a-prodcard__title";
		title.textContent = product.title || "";

		var priceText = formatPrice(product.price_min || product.price);
		if (priceText) {
			var price = document.createElement("div");
			price.className = "hp-a-prodcard__price";
			price.textContent = priceText;
			body.appendChild(title);
			body.appendChild(price);
		} else {
			body.appendChild(title);
		}

		card.appendChild(media);
		card.appendChild(body);

		// Track IntelliGems event when popular pick is clicked
		card.addEventListener("click", function () {
			window.igEvents = window.igEvents || [];
			window.igEvents.push({ event: "popularPickClicked" });
		});

		return card;
	}

	function fetchVehicleProducts(vehicle) {
		/* Cancel any in-flight request so only the latest vehicle wins */
		if (_fetchController) {
			try {
				_fetchController.abort();
			} catch (e) {}
		}
		_fetchController =
			typeof AbortController !== "undefined" ? new AbortController() : null;
		var signal = _fetchController ? _fetchController.signal : undefined;

		var ymmStr = "";
		if (vehicle) {
			ymmStr = vehicle.ymm || "";
			if (!ymmStr) {
				var y = vehicle.year ? String(vehicle.year) : "";
				var mk = vehicle.make ? String(vehicle.make) : "";
				var md = vehicle.model ? String(vehicle.model) : "";
				var sm = vehicle.submodel ? String(vehicle.submodel) : "";
				var en = vehicle.engine ? String(vehicle.engine) : "";
				ymmStr = (y + " " + mk + " " + md + " " + sm + " " + en)
					.replace(/\s+/g, " ")
					.trim();
			}
		}

		var vehicleTopWrap = root.querySelector("[data-hp-vehicle-top]");
		var vehicleProdGrid = root.querySelector("[data-hp-vehicle-prodgrid]");
		var topTitle = root.querySelector("[data-hp-top-title]");

		if (!vehicleTopWrap || !vehicleProdGrid || !topTitle) return;

		// If no vehicle, hide the product grid entirely
		if (!vehicle) {
			vehicleTopWrap.style.display = "none";
			return;
		}

		var primaryHandle = computeVehicleCollectionHandle(vehicle);
		if (!primaryHandle) primaryHandle = fallbackHandle;

		var ymm = String(ymmStr || "").trim();

		if (ymm) {
			topTitle.textContent = "Top Parts for " + ymm;
			syncGarageBarUI(ymm);
		} else {
			// No vehicle: use fallback title
			var fallbackTopTitle =
				root.getAttribute("data-hp-fallback-top-title") ||
				"Top Parts right now";
			topTitle.textContent = fallbackTopTitle;
		}

		// Smooth loading state — preserve layout height, fade out old cards
		var currentHeight = vehicleProdGrid.offsetHeight;
		if (currentHeight > 0) {
			vehicleProdGrid.style.minHeight = currentHeight + "px";
		}
		vehicleProdGrid.style.opacity = "0.35";
		vehicleProdGrid.style.transition = "opacity .2s ease";
		vehicleProdGrid.style.pointerEvents = "none";
		vehicleTopWrap.style.display = "";

		var fetchUrl = "/collections/" + primaryHandle + "/products.json?limit=12";

		// Debug logging (guarded by URL param)
		if (typeof URLSearchParams !== "undefined") {
			try {
				var params = new URLSearchParams(window.location.search);
				if (params.has("hubdebug")) {
					console.debug("[Homepage Hub Debug]", {
						vehicle: vehicle,
						ymmStr: ymmStr,
						computedHandle: primaryHandle,
						fetchUrl: fetchUrl,
					});
				}
			} catch (e) {}
		}

		fetch(fetchUrl, { signal: signal })
			.then(function (res) {
				if (!res.ok) throw new Error("Collection not found");
				return res.json();
			})
			.then(function (data) {
				if (!data.products || data.products.length === 0) {
					// Fallback to top-sellers if primary returns empty
					if (primaryHandle !== fallbackHandle) {
						return fetch(
							"/collections/" + fallbackHandle + "/products.json?limit=12",
						).then(function (res) {
							if (!res.ok) {
								// Try 'all' as ultimate fallback
								return fetch("/collections/all/products.json?limit=12").then(
									function (res2) {
										if (!res2.ok) throw new Error("All collections failed");
										return res2.json();
									},
								);
							}
							return res.json();
						});
					} else {
						// Primary IS the fallback, try 'all' collection
						return fetch("/collections/all/products.json?limit=12").then(
							function (res) {
								if (!res.ok) throw new Error("All collection not found");
								return res.json();
							},
						);
					}
				}
				return data;
			})
			.then(function (data) {
				if (!data.products || data.products.length === 0) {
					vehicleProdGrid.style.minHeight = "";
					vehicleProdGrid.style.opacity = "";
					vehicleProdGrid.style.transition = "";
					vehicleProdGrid.style.pointerEvents = "";
					vehicleTopWrap.style.display = "none";
					return;
				}

				// Build new card fragment off-DOM, then swap in one paint frame
				var frag = document.createDocumentFragment();
				const seenTypes = new Set();
				let renderCount = 0;

				if (data.products && data.products.length > 0) {
					data.products.forEach(function (product) {
						if (!product) return;
						if (renderCount >= 4) return;
						const pType = (product.product_type || "General")
							.trim()
							.toLowerCase();
						if (!seenTypes.has(pType)) {
							try {
								frag.appendChild(renderProductCard(product));
								seenTypes.add(pType);
								renderCount++;
							} catch (err) {
								console.error("Error rendering card:", err);
							}
						}
					});
				}

				if (renderCount > 0) {
					// Swap content and fade in within one rAF
					requestAnimationFrame(function () {
						vehicleProdGrid.innerHTML = "";
						vehicleProdGrid.appendChild(frag);
						vehicleTopWrap.style.display = "block";
						// Force a reflow then fade in
						void vehicleProdGrid.offsetHeight;
						vehicleProdGrid.style.minHeight = "";
						vehicleProdGrid.style.opacity = "1";
						vehicleProdGrid.style.transition = "opacity .25s ease";
						vehicleProdGrid.style.pointerEvents = "";
					});
				} else {
					vehicleProdGrid.style.minHeight = "";
					vehicleProdGrid.style.opacity = "";
					vehicleProdGrid.style.transition = "";
					vehicleProdGrid.style.pointerEvents = "";
				}
			})
			.catch(function (err) {
				if (err && err.name === "AbortError") return; // cancelled by newer switch
				console.warn("Vehicle hub fetch failed", {
					primaryHandle: primaryHandle,
					fallbackHandle: fallbackHandle,
					error: err,
				});
				vehicleProdGrid.style.minHeight = "";
				vehicleProdGrid.style.opacity = "";
				vehicleProdGrid.style.transition = "";
				vehicleProdGrid.style.pointerEvents = "";
				vehicleTopWrap.style.display = "none";
			});
	}

	function openVehicleModal() {
		// Try common selectors for vehicle modal triggers
		var selectors = [
			"[data-open-garage]",
			"[data-ymm-open]",
			".js-open-garage",
			'a[href*="vehicle"]',
			'button:contains("ADD A VEHICLE")',
		];

		for (var i = 0; i < selectors.length; i++) {
			var trigger = document.querySelector(selectors[i]);
			if (trigger) {
				trigger.click();
				return;
			}
		}

		// Fallback: try window function
		if (typeof window.toggleGaragePopup === "function") {
			window.toggleGaragePopup();
		}
	}

	function buildVehicleCategoryUrl(
		vehicle,
		categoryFilter,
		categoryProductType,
	) {
		if (!vehicle || !categoryFilter) return "";
		var baseHandle = computeVehicleCollectionHandle(vehicle);
		if (!baseHandle) return "";

		var gridAnchor = "";
		if (document.querySelector("#ProductGridContainer")) {
			gridAnchor = "#ProductGridContainer";
		} else if (document.querySelector("#product-grid")) {
			gridAnchor = "#product-grid";
		}

		var encodedFilter = encodeURIComponent(categoryFilter);
		var href =
			"/collections/" +
			baseHandle +
			"?filter.p.m.custom.collection_types=" +
			encodedFilter;

		if (categoryProductType) {
			var encodedType = encodeURIComponent(categoryProductType);
			href += "&filter.p.product_type=" + encodedType;
		}

		return href + gridAnchor;
	}

	function getVehicleFromUI() {
		var garageTitle = document.getElementById("garage-vehicle-name");
		var titleText = garageTitle ? garageTitle.textContent || "" : "";
		if (titleText && titleText.toLowerCase().indexOf("select") === -1) {
			return { ymm: titleText.trim() };
		}

		var gridTitle =
			document.querySelector("[data-hp-top-title]") ||
			document.querySelector(".collection-hero__title") ||
			document.querySelector(".section-header__title");
		var gridText = gridTitle ? gridTitle.textContent || "" : "";
		if (gridText.indexOf("Top Parts for") !== -1) {
			var ymm = gridText.replace("Top Parts for", "").trim();
			if (ymm) return { ymm: ymm };
		}
		return null;
	}

	function handlePendingCategoryNavigation(vehicle) {
		if (!vehicle) return;
		var pendingFilter = sessionStorage.getItem("pendingCategoryFilter");
		if (!pendingFilter) return;

		var pendingType = sessionStorage.getItem("pendingCategoryProductType");

		// For Top Categories: redirect to category link after vehicle is entered
		// This applies even on homepage when user clicks a Top Category first
		var targetUrl = buildVehicleCategoryUrl(
			vehicle,
			pendingFilter,
			pendingType,
		);

		sessionStorage.removeItem("pendingCategoryFilter");
		sessionStorage.removeItem("pendingCategoryProductType");
		if (targetUrl) {
			recordVehicleCollectionNavigation(targetUrl, vehicle);
			window.location.href = targetUrl;
		}
	}
	function updateCategoryTileLinks() {
		var tiles = document.querySelectorAll("[data-category-filter]");
		if (!tiles || tiles.length === 0) return;

		const activeVehicle = getActiveVehicle();
		const vehicle = activeVehicle || getVehicleFromUI();

		tiles.forEach(function (tile) {
			var categoryFilter = tile.getAttribute("data-category-filter");
			var categoryProductType = tile.getAttribute("data-category-product-type");
			var defaultHref = tile.getAttribute("data-default-href") || tile.href;
			var productTypeToUse = categoryProductType;
			if (categoryFilter && categoryFilter.indexOf("Bumpers") !== -1) {
				productTypeToUse = null;
			}

			if (vehicle) {
				var href = buildVehicleCategoryUrl(
					vehicle,
					categoryFilter,
					productTypeToUse,
				);
				if (href) tile.setAttribute("href", href);
				observeVehicleCollectionLink(tile, href ? activeVehicle : null);
				tile.onclick = null;
				// Track IntelliGems event when top category navigates
				if (!tile.hasAttribute("data-ig-category-listener-added")) {
					tile.setAttribute("data-ig-category-listener-added", "true");
					tile.addEventListener(
						"click",
						function () {
							window.igEvents = window.igEvents || [];
							window.igEvents.push({ event: "topCategoryNavigated" });
						},
						true,
					);
				}
			} else {
				if (defaultHref) tile.setAttribute("href", defaultHref);
				observeVehicleCollectionLink(tile, null);
				tile.onclick = function (e) {
					e.preventDefault();
					// Track IntelliGems event when top category is clicked (no vehicle)
					window.igEvents = window.igEvents || [];
					window.igEvents.push({ event: "topCategoryNavigated" });

					if (categoryFilter)
						sessionStorage.setItem("pendingCategoryFilter", categoryFilter);
					if (productTypeToUse)
						sessionStorage.setItem(
							"pendingCategoryProductType",
							productTypeToUse,
						);
					openVehicleModal();
				};
			}
		});
	}

	function syncGarageBarUI(ymmText) {
		var garageTitle =
			document.getElementById("garage-vehicle-name") ||
			document.querySelector(".garage-vehicle-text");
		var garageBtn =
			document.querySelector(".garage-bar__btn") ||
			document.querySelector('button[onclick*="openGarage"]') ||
			document.querySelector('button[onclick*="toggleGaragePopup"]') ||
			document.querySelector(".hero-vehicle-hub .btn");

		if (ymmText) {
			if (garageTitle) garageTitle.textContent = ymmText;
			if (garageBtn) {
				garageBtn.textContent = "CHANGE";
				garageBtn.classList.remove("btn-primary");
			}

			/* REMOVED: setSearchTerms([{ymm}]) call that was writing a
			   stripped-down vehicle object back to localStorage, which
			   dispatched searchTermsUpdated and created a feedback loop.
			   The garage modal already persists vehicles via
			   moveVehicleToFront / setSearchTerms — the homepage hub
			   should only READ, never WRITE vehicle state. */

			// Also update top left header selector
			if (
				typeof window.GarageUI !== "undefined" &&
				window.GarageUI.updateVehicleSelectionElement
			) {
				window.GarageUI.updateVehicleSelectionElement(ymmText);
			}

			/* NOTE: Previously there was a setTimeout that called
			   toggleGaragePopup() to auto-close the old popup.
			   This was closing the V2 garage modal because
			   window.toggleGaragePopup now points to V2's toggle().
			   The V2 garage handles its own close logic — the homepage
			   hub should NEVER close the garage modal. */
		} else {
			if (garageTitle) garageTitle.textContent = "Select Your Vehicle";
			if (garageBtn) {
				garageBtn.textContent = "ADD VEHICLE";
				garageBtn.classList.add("btn-primary");
			}
			// Also update top left header selector
			if (
				typeof window.GarageUI !== "undefined" &&
				window.GarageUI.updateVehicleSelectionElement
			) {
				window.GarageUI.updateVehicleSelectionElement(null);
			}
		}
	}

	window.syncGarageBarUI = syncGarageBarUI;

	function applyState() {
		var vehicle = getActiveVehicle();
		var ymmTitle = root.querySelector("[data-hp-selected-title]");
		var subtitle = root.querySelector("[data-hp-selected-subtitle]");
		var viewAll = root.querySelector("[data-hp-view-all]");
		var selectedHeadingTpl =
			window.hpHubSelectedHeading || "Top Parts for your {ymm}";
		var fallbackUrl = window.hpHubFallbackUrl || "/collections";

		// Always show vehicle-style layout
		root.classList.add("is-selected");

		// Detect product grid anchor
		var gridAnchor = "";
		if (document.querySelector("#ProductGridContainer")) {
			gridAnchor = "#ProductGridContainer";
		} else if (document.querySelector("#product-grid")) {
			gridAnchor = "#product-grid";
		}

		if (vehicle) {
			// Vehicle exists: show vehicle-specific content
			var ymm =
				vehicle.ymm ||
				(vehicle.year || "") +
					" " +
					(vehicle.make || "") +
					" " +
					(vehicle.model || "");
			ymm = String(ymm || "").trim();

			if (ymmTitle)
				ymmTitle.textContent = selectedHeadingTpl.replace("{ymm}", ymm);
			syncGarageBarUI(ymm);

			if (subtitle) {
				var selectedSubtitle = root.getAttribute(
					"data-hp-selected-subtitle-text",
				);
				if (selectedSubtitle) subtitle.textContent = selectedSubtitle;
			}

			var url = computeVehicleCollectionUrl(vehicle);
			if (url && gridAnchor) url += gridAnchor;
			if (viewAll) {
				viewAll.setAttribute("href", url || fallbackUrl);
				observeVehicleCollectionLink(viewAll, url ? vehicle : null);
				// Track IntelliGems event when view all parts is clicked (only add once)
				if (!viewAll.hasAttribute("data-ig-listener-added")) {
					viewAll.setAttribute("data-ig-listener-added", "true");
					viewAll.addEventListener("click", function () {
						window.igEvents = window.igEvents || [];
						window.igEvents.push({ event: "viewAllPartsClicked" });
					});
				}
			}

			fetchVehicleProducts(vehicle);
		} else {
			// No vehicle: show fallback content
			var fallbackTitle =
				root.getAttribute("data-hp-fallback-title") ||
				"Popular picks right now";
			var fallbackSubtitle =
				root.getAttribute("data-hp-fallback-subtitle") ||
				"Add a vehicle for exact fitment, or browse top-selling painted parts.";

			if (ymmTitle) ymmTitle.textContent = fallbackTitle;
			if (subtitle) subtitle.textContent = fallbackSubtitle;

			// Set "view all parts" to /collections/all when no vehicle
			var viewAllUrl = "/collections/all";
			if (viewAll) {
				viewAll.setAttribute("href", viewAllUrl);
				observeVehicleCollectionLink(viewAll, null);
				// Track IntelliGems event when view all parts is clicked (only add once)
				if (!viewAll.hasAttribute("data-ig-listener-added")) {
					viewAll.setAttribute("data-ig-listener-added", "true");
					viewAll.addEventListener("click", function () {
						window.igEvents = window.igEvents || [];
						window.igEvents.push({ event: "viewAllPartsClicked" });
					});
				}
			}

			// Hide product grid when no vehicle
			var vehicleTopWrap = root.querySelector("[data-hp-vehicle-top]");
			if (vehicleTopWrap) vehicleTopWrap.style.display = "none";
			syncGarageBarUI(null);
		}

		// Update category tile routing after state is applied
		initDynamicCategoryTiles();
		// Always rewrite [data-category-filter] tiles (e.g. hp-a-catcard) for the
		// current vehicle state. initDynamicCategoryTiles only calls this in its
		// no-vehicle branch, so without this the fallback tiles keep their
		// hardcoded href="/collections" whenever a vehicle is in the garage.
		updateCategoryTileLinks();
		handlePendingCategoryNavigation(vehicle);
	}

	function checkVehicleChange() {
		var vehicle = getActiveVehicle();
		var currentJson = JSON.stringify(vehicle || null);

		if (currentJson !== lastVehicleJson) {
			lastVehicleJson = currentJson;
			applyState();
		}
	}

	function startPolling() {
		if (pollInterval) return;

		pollCount = 0;
		pollInterval = setInterval(function () {
			checkVehicleChange();
			pollCount++;

			// Fast poll for 5 seconds (12 * 400ms = 4.8s), then slow poll
			if (pollCount > 12) {
				clearInterval(pollInterval);
				pollInterval = setInterval(checkVehicleChange, 1500);
			}
		}, 400);
	}

	function attachGarageButtons() {
		var buttons = root.querySelectorAll(".js-open-garage");
		if (!buttons || !buttons.length) return;

		function fallbackClick() {
			var textToFind = "SELECT OR ADD A VEHICLE";
			var candidates = Array.prototype.slice.call(
				document.querySelectorAll("button, a"),
			);
			for (var i = 0; i < candidates.length; i++) {
				var el = candidates[i];
				if (!el || !el.textContent) continue;
				if (el.textContent.trim().toUpperCase().indexOf(textToFind) !== -1) {
					try {
						el.click();
						return;
					} catch (e) {}
				}
			}
		}

		buttons.forEach(function (btn) {
			btn.addEventListener("click", function () {
				if (typeof window.toggleGaragePopup === "function") {
					window.toggleGaragePopup();
				} else {
					fallbackClick();
				}
				startPolling();
			});
		});
	}

	/* ── Dynamic category tiles: count-based routing ── */
	async function fetchProductsByType(collectionHandle) {
		// tabMap: collection_types group label → Map<productType, { products[], image }>
		const tabMap = new Map();

		const query = `
      query getVehicleProducts($handle: String!) {
        collection(handle: $handle) {
          products(first: 250) {
            edges {
              node {
                handle
                productType
                featuredImage {
                  url(transform: { maxWidth: 400, maxHeight: 400, crop: CENTER })
                }
                collectionType: metafield(namespace: "custom", key: "collection_types") {
                  value
                }
              }
            }
          }
        }
      }
    `;

		try {
			const storefrontToken =
				window.shopCurrency === "CAD"
					? "2bcf68ed45edc56c19f2f3aa226eb101"
					: "44a939c332cecf3e7d07afc3cdc65b09";
			const res = await fetch("/api/2023-10/graphql.json", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Shopify-Storefront-Access-Token": storefrontToken,
				},
				body: JSON.stringify({
					query,
					variables: { handle: collectionHandle },
				}),
			});

			if (!res.ok) return tabMap;
			const json = await res.json();
			if (json.errors) return tabMap;

			const edges = json?.data?.collection?.products?.edges || [];

			for (const { node } of edges) {
				const ptype = (node.productType || "").trim();
				if (!ptype) continue;

				const raw = node.collectionType?.value || "";
				let ctypes = [];
				try {
					ctypes = JSON.parse(raw);
				} catch {
					ctypes = raw ? [raw] : [];
				}

				for (const ctype of ctypes) {
					const tabGroup = ctype.trim();
					if (!tabGroup) continue;

					if (!tabMap.has(tabGroup)) tabMap.set(tabGroup, new Map());
					const groupMap = tabMap.get(tabGroup);

					if (!groupMap.has(ptype)) {
						groupMap.set(ptype, {
							products: [],
							image: null,
							label: ptype,
						});
					}

					const entry = groupMap.get(ptype);
					entry.products.push(node);
					if (!entry.image && node.featuredImage?.url) {
						entry.image = node.featuredImage.url;
					}
				}
			}
		} catch (err) {
			console.warn("[Partify] fetchProductsByType error:", err);
		}

		return tabMap;
	}

	async function initDynamicCategoryTiles() {
		const grid = document.getElementById("CarIDGrid");
		if (!grid) return;

		// ── 1. Read vehicle ────────────────────────────────────────────────
		const vehicle =
			typeof getActiveVehicle === "function"
				? getActiveVehicle()
				: (() => {
						try {
							return (
								JSON.parse(localStorage.getItem("searchTerms"))?.[0] || null
							);
						} catch {
							return null;
						}
					})();

		if (!vehicle) {
			if (typeof updateCategoryTileLinks === "function")
				updateCategoryTileLinks();
			return;
		}

		grid.classList.add("carid-loading");

		// ── 2. Build handle with submodel/engine fallback ──────────────────
		const slugify = (str) =>
			str
				.toLowerCase().replace(/[./+:]/g, "-").replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/-+$/, "");
		const parts = (vehicle.ymm || "").trim().split(/\s+/);
		const ymmCandidates = [
			...new Set(
				Array.from({ length: Math.max(0, parts.length - 2) }, (_, i) =>
					slugify(parts.slice(0, parts.length - i).join(" ")),
				),
			),
		];
		// Always try the full stored handle (lastCollection / collectionHandle) first
		// so engine/trim-specific handles like "2023-gmc-sierra-1500-denali-8-cyl-5-3l"
		// are not truncated to just the base ymm handle.
		const storedHandle = computeVehicleCollectionHandle(vehicle);
		const candidates = [
			...new Set([storedHandle, ...ymmCandidates].filter(Boolean)),
		];

		let handle = candidates[0] || slugify(vehicle.ymm);
		let tabMap = new Map();

		for (const candidate of candidates) {
			const result = await fetchProductsByType(candidate);
			if (result.size > 0) {
				handle = candidate;
				tabMap = result;
				break;
			}
		}

		if (tabMap.size === 0) {
			grid.classList.remove("carid-loading");
			if (typeof updateCategoryTileLinks === "function")
				updateCategoryTileLinks();
			return;
		}
		// ── 3. Tab definitions — maps data-group to collection_types label ─
		const TAB_DEFINITIONS = [
			{ group: "Front Bumpers", label: "Front Bumpers & Components" },
			{ group: "Rear Bumpers", label: "Rear Bumpers & Components" },
			{ group: "Lighting", label: "Lights & Components" },
			{ group: "Body Panels", label: "Fenders & Components" },
			{ group: "Body Panels", label: "Hoods & Components" },
			{ group: "Grilles", label: "Grilles & Components" },
			{ group: "Mirrors/Doors", label: "Mirrors & Components" },
		];

		const groupCards = new Map();
		TAB_DEFINITIONS.forEach((def) => {
			if (!groupCards.has(def.group)) groupCards.set(def.group, []);
		});

		for (const def of TAB_DEFINITIONS) {
			const groupMap = tabMap.get(def.label);
			if (!groupMap) continue;

			for (const [ptype, entry] of groupMap) {
				groupCards.get(def.group).push({
					label: ptype,
					image: entry.image,
					products: entry.products,
					collectionLabel: def.label,
					group: def.group,
				});
			}
		}

		// ── 4. Remember active tab before clearing ─────────────────────────
		const activeTabGroup =
			document.querySelector("#CarIDTabs .active")?.dataset?.group ||
			"Front Bumpers";

		// ── 5. Clear existing cards and render dynamic ones ─────────────────
		grid.querySelectorAll(".carid-card").forEach((c) => c.remove());

		let cardsRendered = 0;

		for (const [group, cards] of groupCards) {
			if (cards.length === 0) continue;

			for (const card of cards) {
				const href = `/collections/${handle}?filter.p.m.custom.collection_types=${encodeURIComponent(card.collectionLabel)}&filter.p.product_type=${encodeURIComponent(card.label)}`;

				const el = document.createElement("a");
				el.className = "carid-card";
				el.href = href;
				observeVehicleCollectionLink(el, vehicle);
				el.dataset.group = card.group;
				el.dataset.categoryFilter = card.collectionLabel;
				el.dataset.categoryProductType = card.label;
				el.style.display = card.group === activeTabGroup ? "" : "none";

				const _fallbackSrc =
					"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Partify_Photo_Coming_Soon.png?v=1747228850";
				el.innerHTML = `
					<div class="carid-card__img-wrap">
						${
							card.image
								? `<img src="${card.image}" alt="${card.label}" loading="lazy" onerror="this.onerror=null;this.src='${_fallbackSrc}'">`
								: `<img src="${_fallbackSrc}" alt="${card.label}" loading="lazy">`
						}
					</div>
					<p class="carid-card__label">${card.label}</p>
				`;

				grid.appendChild(el);
				cardsRendered++;
			}
		}

		grid.classList.remove("carid-loading");

		// ── 6. Rebind tab click system to use our new dynamic cards ─────────
		const tabsEl = document.getElementById("CarIDTabs");
		if (tabsEl) {
			const newTabsEl = tabsEl.cloneNode(true);
			tabsEl.parentNode.replaceChild(newTabsEl, tabsEl);

			newTabsEl.querySelectorAll("[data-group]").forEach((btn) => {
				btn.addEventListener("click", () => {
					const targetGroup = btn.dataset.group;
					newTabsEl
						.querySelectorAll("[data-group]")
						.forEach((b) => b.classList.remove("active"));
					btn.classList.add("active");
					document
						.querySelectorAll("#CarIDGrid .carid-card")
						.forEach((card) => {
							card.style.display =
								card.dataset.group === targetGroup ? "" : "none";
						});
				});
			});
		}

		// ── 7. Update tab visibility ───────────────────────────────────────
		document.querySelectorAll("#CarIDTabs [data-group]").forEach((btn) => {
			const hasCards = (groupCards.get(btn.dataset.group) || []).length > 0;
			btn.classList.toggle("carid-tab--hidden", !hasCards);
		});

		// ── 8. Activate the correct tab ────────────────────────────────────
		const targetBtn =
			document.querySelector(
				`#CarIDTabs [data-group="${activeTabGroup}"]:not(.carid-tab--hidden)`,
			) ||
			document.querySelector("#CarIDTabs [data-group]:not(.carid-tab--hidden)");
		if (targetBtn) targetBtn.click();

		// ── 9. Wheel scroll — attach after cards are rendered ────────────────
		if (grid._wheelHandler) {
			grid.removeEventListener("wheel", grid._wheelHandler);
		}
		grid._wheelHandler = function (e) {
			if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
				e.preventDefault();
				grid.scrollBy({ left: e.deltaY * 1.5, behavior: "auto" });
			}
		};
		grid.addEventListener("wheel", grid._wheelHandler, { passive: false });
	}

	// Expose product fetch for auto-load helpers
	if (typeof window.fetchVehicleProducts !== "function") {
		window.fetchVehicleProducts = function (year, make, model) {
			if (year && typeof year === "object") {
				fetchVehicleProducts(year);
				return;
			}
			fetchVehicleProducts({
				year: year || "",
				make: make || "",
				model: model || "",
			});
		};
	}

	// Expose for external searchTermsUpdated listener
	window._partifyInitDynamicCategoryTiles = initDynamicCategoryTiles;

	// Initialize
	attachGarageButtons();

	var vehicle = getActiveVehicle();
	lastVehicleJson = JSON.stringify(vehicle || null);
	applyState();

	// Cross-tab sync
	window.addEventListener("storage", function (e) {
		if (e && e.key === "searchTerms") debouncedVehicleCheck();
	});

	/* ── Same-tab vehicle change listeners (Fix F) ──
	   Use a single debounced handler for ALL vehicle-change signals.
	   This collapses the 3–5 events from a single switch into one update. */
	function debouncedVehicleCheck() {
		if (_vehicleChangeTimer) clearTimeout(_vehicleChangeTimer);
		_vehicleChangeTimer = setTimeout(function () {
			_vehicleChangeTimer = null;
			checkVehicleChange();
		}, 120);
	}
	window.addEventListener("partify:vehicle:changed", debouncedVehicleCheck);
	window.addEventListener("searchTermsUpdated", debouncedVehicleCheck);

	// Also register with shared batcher for belt-and-suspenders dedup
	if (window.__partifyVehicleChangeBatcher) {
		window.__partifyVehicleChangeBatcher.onVehicleChange(function () {
			checkVehicleChange();
		});
	}
})();

document.addEventListener("DOMContentLoaded", function () {
	const productGridTitle =
		document.querySelector(".collection-hero__title") ||
		document.querySelector(".section-header__title") ||
		document.querySelector("[data-hp-top-title]");

	let activeVehicle = null;
	if (productGridTitle) {
		const text = productGridTitle.innerText || "";
		if (text.includes("Top Parts for")) {
			activeVehicle = text.replace("Top Parts for", "").trim();
		} else if (text.includes("for ")) {
			activeVehicle = text.split("for ")[1].trim();
		}
	}

	if (activeVehicle) {
		window.syncGarageBarUI(activeVehicle);
		return;
	}

	try {
		const memory = JSON.parse(localStorage.getItem("searchTerms"));
		if (memory && memory.length > 0 && memory[0].ymm) {
			window.syncGarageBarUI(memory[0].ymm);
		} else {
			window.syncGarageBarUI(null);
		}
	} catch (e) {
		window.syncGarageBarUI(null);
	}
});

window.addEventListener("searchTermsUpdated", function () {
	if (typeof window._partifyInitDynamicCategoryTiles === "function") {
		window._partifyInitDynamicCategoryTiles();
	}
});
